import type { ArticleTileContent } from "@composites/ArticleTile/ArticleTile.types";
import type { ESectionSpacing, ESectionTheme } from "@layout/Section/Section.types";
import type { HeadingLevel } from "@primitives/Heading/Heading.types";

/** The emitted control's value. Never authored — a filter carrying it would shadow it. */
export const ARTICLE_LISTING_ALL = "all";

/** The capacity the Figma node draws as four rows of three. */
export const ARTICLE_LISTING_PER_PAGE = 12;

/** At least 1: an empty listing still has a page, it is just empty. */
export const pageCountFor = (total: number, perPage: number): number =>
	Math.max(1, Math.ceil(total / perPage));

export type ArticleListingFilter = {
	label: string;
	/** The stable category slug every article is matched on, never the visible label. */
	value: string;
};

export type ArticleListingContent = {
	filters: readonly ArticleListingFilter[];
	articles: readonly ArticleTileContent[];
	/** Shown when a filter selects nothing. Omitted, the listing is simply empty. */
	emptyMessage?: string;
};

export type ArticleListingProps = {
	content: ArticleListingContent;
	/** Defaults to `tertiary`, the ground Figma draws. */
	theme?: ESectionTheme;
	/** Defaults to `md` — 96px, which is what the node binds. */
	spacing?: ESectionSpacing;
	scrollId?: string;
	/** Defaults to 3 — each tile's heading; the block renders none of its own. */
	headingLevel?: HeadingLevel;
	idPrefix: string;
	/** Articles per page. Defaults to `ARTICLE_LISTING_PER_PAGE`. */
	perPage?: number;
	label?: string;
	allLabel?: string;
	filtersLabel?: string;
	/** `{from}`, `{to}` and `{total}` are substituted on every filter and page change. */
	resultsTemplate?: string;
	paginationLabel?: string;
	previousLabel?: string;
	nextLabel?: string;
	/** `{page}` is substituted into each page number's accessible name. */
	pageLabel?: string;
	className?: string;
};
